import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Icon } from "@/lib/icons";

// Drive-backed profile photo uploader (same pattern as Garden Plots / Events).
// `endpoint` is the POST path that accepts multipart `file` and returns { photo_url }.
export default function PhotoUpload({ endpoint, photoUrl, onUploaded, label = "Upload photo", testid = "photo-upload", size = 96 }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = () => inputRef.current && inputRef.current.click();
  const onFile = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!f.type.startsWith("image/")) return toast.error("Please choose an image file.");
    const fd = new FormData();
    fd.append("file", f);
    setBusy(true);
    try {
      const r = await api.post(endpoint, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Photo updated");
      onUploaded && onUploaded(r.data.photo_url);
    } catch (err) { toast.error(err.response?.data?.detail || "Upload failed"); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-4" data-testid={testid}>
      <div className="rounded-full overflow-hidden bg-olive/15 border border-ink/15 flex items-center justify-center shrink-0"
           style={{ width: size, height: size }}>
        {photoUrl ? <img src={photoUrl} alt="Profile" data-testid={`${testid}-img`} className="w-full h-full object-cover" />
                  : <Icon name="User" className="w-8 h-8 text-olive" />}
      </div>
      <div>
        <button data-testid={`${testid}-btn`} onClick={pick} disabled={busy}
          className="inline-flex items-center gap-1.5 bg-ink text-cream rounded-lg px-4 py-2 min-h-[42px] text-[14px] font-semibold disabled:opacity-60">
          <Icon name="Upload" className="w-4 h-4" /> {busy ? "Uploading…" : (photoUrl ? "Replace photo" : label)}
        </button>
        <input ref={inputRef} type="file" accept="image/*" onChange={onFile} className="hidden" data-testid={`${testid}-input`} />
        <p className="text-[12px] text-ink/50 mt-1">JPG or PNG, up to 15 MB.</p>
      </div>
    </div>
  );
}
